<template>
  <el-dialog v-dialogDrag :title="personChooseTitle" :visible.sync="personChooseDialog" :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="1000px" :append-to-body="true" @close="close">
    <el-tabs v-model="peopleType" @tab-click="peopleTypeChange">
      <el-tab-pane label="选择人员" name="1" style1="max-height: 500px; overflow: scroll">
        <el-row :gutter="20" type="flex" align="center">
          <el-col :span="9">
            <el-input v-model="filter.text" placeholder="输入关键字进行过滤" clearable size="small">
            </el-input>
          </el-col>
          <el-col v-if="canFilterByRole" :span="9">
            <el-select v-model="filter.roleIds" size="small" style="width: 100%" placeholder="请选择角色" filterable multiple>
              <el-option v-for="item in sysData" :key="item.roleID" :label="item.roleName" :value="item.roleID">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="btn">
              <el-button type="primary" size="small" @click="handleFilter">筛选</el-button>
              <el-button size="small" @click="handleReset">重置</el-button>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top:20px" :gutter="20">
          <el-col :span="6">
            <el-tree ref="deptree" :data="orgTree" :props="defaultProps" :filter-node-method="filterNode"
              :default-expanded-keys="defaultExpandedKeys" class="filter-tree" node-key="deptId" check-strictly
              @node-click="handleNodeClick">
              <template #default="{ data }">
                <div style="display:flex;align-items:center">
                  <img :src="icon" style=" margin-right: 6px" alt="部门图片" />
                  <span style="font-size:14px">{{ data.deptName }}</span>
                </div>
              </template>
            </el-tree>
          </el-col>
          <el-col class="col" :span="18">
            <div class="tabWrap">
              <el-table ref="multipleTable" class="parmiss" :data="userList" border highlight-current-row row-key="onlyId" @selection-change="selectChange" @row-click="rowClick">
                <template slot="empty">
                  <img :src="zanwu" alt="" />
                  <p style="font-size:16px;color:#000;">暂无数据</p>
                </template>
                <el-table-column v-if="showSelection" type="selection" width="42" header-align="center" align="center" reserve-selection></el-table-column>
                <el-table-column show-overflow-tooltip align="center" label="姓名" prop="fullName" sortable>
                  <template #default="{row}">
                    <span>{{ row.fullName }}{{ row.isHead ? '【负责人】' : '' }}</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center" label="账号" prop="userName" sortable>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center" label="性别" prop="gender" sortable>
                  <template #default="{row}">
                    <span v-if="row.gender == '1'">男</span>
                    <span v-if="row.gender == '2'">女</span>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="orgName" align="center" label="所在部门" sortable />
                <el-table-column show-overflow-tooltip prop="spec" align="center" label="专业" sortable />
              </el-table>
            </div>
            <div style="height: 32px;">
              <div class="page-1">
                <el-pagination background :total="totalCount" :page-size="pageSize" :current-page.sync="pageIndex"
                  layout="->, total, prev, pager, next" @current-change="getOrgPerson" />
              </div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane v-if="sysRoleTabVisible&&!transfer" label="选择系统角色" name="2">
        <template>
          <el-input v-model="filterTextSys" placeholder="输入关键字进行过滤" clearable size="small">
          </el-input>
          <el-tree key="roleID" ref="systree" :data="sysData" :props="defaultRoleProps"
            :filter-node-method="filterNode2" show-checkbox class="filter-tree" node-key="roleID"
            @check="roleCheckChange">
            <template #default="{ data }">
              <div style="display:flex;align-items:center">
                <img :src="roleIcon" style=" margin-right: 6px" alt="角色图片" />
                <span style="font-size:14px">{{ data.roleName }}</span>
              </div>
            </template>
          </el-tree>
        </template>
      </el-tab-pane>
      <el-tab-pane v-if="specRoleTabVisible&&!transfer" label="选择专业角色" name="3">
        <template>
          <el-input v-model="filterTextRole" placeholder="输入关键字进行过滤" clearable size="small">
          </el-input>
          <el-tree key="roleId" ref="roletree" :data="roleData" :props="defaultRoleProps"
            :filter-node-method="filterNode2" show-checkbox class="filter-tree" node-key="roleId"
            @check="prjSpecRoleCheckChange">
            <template #default="{ data }">
              <div style="display:flex;align-items:center">
                <img :src="data.isSpec ? specIcon : roleIcon" style=" margin-right: 6px"
                  :alt="data.isSpec ? '专业图片' : '角色图片'" />
                <span style="font-size:14px">{{ data.roleName }}</span>
              </div>
            </template>
          </el-tree>
        </template>
      </el-tab-pane>
      <el-tab-pane v-if="projectRoleTabVisible&&!transfer" label="选择项目角色" name="4">
        <template>
          <el-input v-model="filterTextProjectRole" placeholder="输入关键字进行过滤" clearable size="small">
          </el-input>
          <el-tree key="roleID" ref="projectTree" :data="projectRoleData" :props="projectdefaultProps"
            :filter-node-method="filterNode2" show-checkbox class="filter-tree" node-key="roleID"
            @check="projectRoleCheckChange">
            <template #default="{ data }">
              <div style="display:flex;align-items:center">
                <span style="font-size:14px">{{ data.roleName }}</span>
              </div>
            </template>
          </el-tree>
        </template>
      </el-tab-pane>
    </el-tabs>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button type="primary" size="small" @click="peopleDetermine">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
// 只用这个组件，其他选人的组件不用
import flowService from "@/CommonDP/service/flow-service";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  props: {
    // 外部传入的已选列表，进行回显
    selectList: {
      type: Array,
      default: () => []
    },
    // 允许设置角色 id（角色 id 为 array 类型），从而加载数据时就能限定人员数量
    roleIds: {
      type: Array,
      default: () => []
    },
    // （2）canFilterByRole: 默认 true, 控制选择人员下的 按角色筛选下拉框；
    canFilterByRole: { type: Boolean, default: true },
    // （3）canSelectSystemRole: 默认 true, 控制选择系统角色这个 tab 的显示、隐藏；
    canSelectSystemRole: { type: Boolean, default: true },
    // （4）canSelectspecRole: 默认 true, 控制选择项目角色这个 tab 的显示、隐藏；
    canSelectspecRole: { type: Boolean, default: true },
    canSelectprojectRole: { type: Boolean, default: true },
    showSelection: { type: Boolean, default: true }
  },

  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folderChild.png"),
      specIcon: require("@/CommonDP/assets/doc/spec.png"),
      roleIcon: require("@/CommonDP/assets/doc/role.png"),
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      userList: [],
      transfer: "",
      personType: "",
      personChooseDialog: false,
      personChooseTitle: "选择人员",
      peopleType: "1",
      filter: {
        text: "",
        roleIds: []
      },
      filterTextRole: "",
      filterTextProjectRole: "",
      filterTextSys: "",
      defaultExpandedKeys: [],
      orgTree: [],
      roleData: [],
      projectRoleData: [],
      sysData: [],
      defaultProps: {
        children: "children",
        label: "deptName"
      },
      projectdefaultProps: {
        label: "roleName"
      },
      userId: "",
      // 0-审批人，1-抄送人
      type: 0,
      params: {},
      defaultRoleProps: {
        children: "children",
        label: "roleName"
      },
      curDept: {},
      roleSelectList: [],
      pageIndex: 1,
      pageSize: 20,
      totalCount: 0,
      pageLayout: "total, prev, pager, next,jumper" // 分页组件
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      userInfo: state => state.user.userInfo,
      routerParams: state => state.projectMg.routerParams
    }),
    sysRoleTabVisible() {
      if (Reflect.has(this.params, "canSelectSystemRole")) {
        return !!this.params.canSelectSystemRole;
      } else {
        return this.canSelectSystemRole;
      }
    },
    specRoleTabVisible() {
      if (Reflect.has(this.params, "canSelectspecRole")) {
        return !!this.params.canSelectspecRole;
      } else {
        return this.canSelectspecRole;
      }
    },
    projectRoleTabVisible() {
      if (Reflect.has(this.params, "canSelectprojectRole")) {
        return !!this.params.canSelectprojectRole;
      } else {
        return this.canSelectprojectRole;
      }
    }
  },

  watch: {
    filterTextRole(val) {
      this.$refs.roletree.filter(val);
    },

    filterTextSys(val) {
      this.$refs.systree.filter(val);
    },
    filterTextProjectRole(val) {
      this.$refs.projectTree.filter(val);
    }
  },

  methods: {
    // 接口：弹出对话框
    show(title, params, resetSelection) {
      this.personChooseTitle = title || "选择人员";
      this.params = params || {};
      if (params) {
        this.type = params.type || 0;
        this.transfer = params.transfer || "";
      }
      this.pageIndex = 1;
      this.pageSize = 10;
      this.personChooseDialog = true;
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
      });
      this.peopleTypeChange();
      // 如果有值，就代表有数据要回显
      if (!resetSelection && this.selectList?.length) {
        this.$nextTick(() => {
          const list = _.cloneDeep(this.selectList);
          this.roleSelectList = list.map(item => {
            return {
              deptName: item.userName,
              deptId: item.userId
            };
          });
          const keys = this.roleSelectList.map(item => item.deptId);
          this.$refs.deptree.setCheckedKeys(keys);
        });
      }
    },
    handleNodeClick(data) {
      this.curDept = data;
      this.getOrgPerson();
    },
    roleCheckChange(data, currentChecked) {
      this.roleSelectList = currentChecked.checkedNodes;
    },
    prjSpecRoleCheckChange(data, currentChecked) {
      this.roleSelectList = currentChecked.checkedNodes;
    },
    projectRoleCheckChange(data, currentChecked) {
      this.roleSelectList = currentChecked.checkedNodes;
    },
    selectChange(data) {
      this.roleSelectList = data;
      console.log(this.roleSelectList, 'selectChange');
    },
    rowClick(data) {
      if (!this.showSelection) {
        this.roleSelectList = [];
        this.roleSelectList.push(data);
      }
    },
    handleFilter() {
      this.pageIndex = 1;
      this.getOrgPerson();
    },
    handleReset() {
      this.resetFilter();
      this.handleFilter();
    },

    resetFilter() {
      this.filter = {
        text: "",
        roleIds: []
      };
      this.filterTextRole = "";
      this.filterTextSys = "";
      this.filterTextProjectRole = "";
    },
    filterNode2(value, data) {
      if (!value) return true;
      return data.roleName.indexOf(value) !== -1;
    },
    handleCheckChange(data, checked) {
      if (checked) {
        if (data.type === 1) {
          this.roleSelectList = data;
        }
        this.$refs.deptree.setCheckedNodes([data]);
      }
    },
    async peopleTypeChange() {
      this.resetFilter();
      switch (this.peopleType) {
        case "1":
          await this.getOrgList();
          this.getOrgPerson();
          this.getSysList();
          break;
        case "2":
          this.getSysList();
          break;
        case "3":
          this.getRoleList();
          break;
        case "4":
          this.queryRoleListFlow();
          break;
        default:
          this.getOrgList();
          break;
      }
    },
    // 获取项目角色
    async queryRoleListFlow() {
      if (this.projectRoleData?.length) return;
      const res = await flowService.queryRoleListFlow(this.routerParams.enterpriseId || this.enterpriseId);
      this.projectRoleData = res.data || [];
    },
    // 项目 角色
    async getRoleList() {
      if (this.roleData?.length) return;
      const res = await flowService.querySpecRoleTree(this.routerParams.enterpriseId || this.enterpriseId);
      this.roleData =
        res.data?.map(item => {
          item.isSpec = true;
          return item;
        }) || [];
    },

    // 系统 角色
    async getSysList() {
      if (this.sysData?.length) return;
      const res = await flowService.querySysRoleList(this.routerParams.enterpriseId || this.enterpriseId);
      this.sysData = res.data.map(item => {
        // item.children.children = [];
        return item;
      });
    },

    // 部门 人员
    async getOrgList() {
      if (this.orgTree?.length) return;
      const res = await flowService.getPersonChooseOrgTree(this.routerParams.enterpriseId || this.enterpriseId);
      console.log(res, "res");
      this.orgTree = res.data;
      this.curDept = this.orgTree[0];
      if (res.data && res.data.length > 0) {
        this.defaultExpandedKeys.push(res.data[0].deptId);
      }
    },

    async getOrgPerson() {
      const params = {
        orgId: this.curDept.deptId || this.orgTree[0].deptId, // 必填
        keyword: this.filter.text,
        sysRoleId: this.filter.roleIds,
        pageNo: this.pageIndex,
        pageSize: this.pageSize
      };
      const { data, totalCount, pageIndex } = await flowService.getPersonChooseOrgUser(params);
      this.pageIndex = pageIndex;
      this.totalCount = totalCount;
      data.forEach(ele => {
        this.$set(ele, 'onlyId', ele.userId + ele.orgId);
      });
      this.userList = data;
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.deptName.indexOf(value) !== -1;
    },
    containsCurrentUser() {
      return this.roleSelectList.some(item => item.id === this.userInfo.userId);
    },
    formatData() {
      const list = this.roleSelectList.map(item => {
        let obj;
        switch (this.peopleType) {
          case "1":
            obj = {
              name: item.fullName,
              userId: item.id,
              type: 0
            };
            break;
          case "2":
            obj = {
              name: item.roleName,
              userId: item.roleID,
              type: 1
            };
            break;
          case "3":
            obj = {
              name: item.roleName,
              userId: item.roleId,
              type: 2
            };
            break;
          case "4":
            obj = {
              name: item.roleName,
              userId: item.roleID,
              type: 3
            };
            break;
          default:
            break;
        }
        return obj;
      });
      return list;
    },
    peopleDetermine() {
      if (this.transfer && this.containsCurrentUser()) {
        this.$warn("不能选择自己！");
        this.roleSelectList = [];
      } else {
        const list = this.formatData();
        this.personChooseDialog = false;
        this.$emit("userSelected", list, this.type, this.params);
        // 为了兼容而保留
        this.$emit("personChoose", list, this.type, this.params);
      }
    },
    close() {
      this.personChooseDialog = false;
      this.peopleType = "1";
      this.resetFilter();
      this.roleSelectList = [];
      this.projectRoleData = [];
      this.roleData = [];
      this.sysData = [];
      this.orgTree = [];

      this.type = 0;
    }
  }
};
</script>
<style lang="scss" scoped>
.filter-tree {
  overflow: auto;
  height: 400px;
  max-height: 450px;
}
.parmiss {
  width: 100%;
  border: 1px solid #eee;
  border-bottom: 0px solid #eee;
  border-collapse: collapse;
}
.tabWrap {
  height: 450px;
  overflow: auto;
}
.btn {
  height: 100%;
  display: flex;
  align-items: center;
}
.col {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
</style>
